import React, { useCallback, useEffect, useRef, useState, } from 'react';
import styled, { css } from 'styled-components';
import { hasElementScrollbar } from '../../../utils/misc';
import Portal from '../../Atoms/Portal';
import { Icon, IconLookup } from '../../Atoms/Icon';
const StyledContainer = styled.div ``;
const StyledOverlay = styled.div `
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2.666666667rem;
  background-color: rgba(51, 55, 61, 0.8);
`;
const StyledInnerContainer = styled.div `
  display: flex;
  flex-direction: column;
  padding: 1.333333333rem;
  background-color: #fff;
  font-size: 1.166666667rem;
  box-sizing: border-box;
`;
const StyledHeader = styled.div `
  position: relative;
  display: flex;
  align-items: center;
`;
const StyledTitle = styled.h2 `
  margin: 0 1rem 0 0;
  font-size: 2.333333333rem;
  word-break: break-word;
`;
const StyledContent = styled.div `
  flex: 1;
  overflow: auto;

  ${({ existsTitle }) => existsTitle && css `
    margin-top: 1.333333333rem;
  `}

  ${({ hasScrollbar }) => hasScrollbar && css `
    padding-right: 1rem;
  `}
`;
const StyledIcon = styled(Icon) `
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  font-size: 1.583333333rem;
  font-weight: 700;
`;
const Modal = ({ children, className, overlayClassName, containerClassName, headerClassName, titleClassName, closeIconClassName, contentClassName, title, isOpen = false, onOpen = () => { }, onClose = () => { }, modalFooterComponent: ModalFooter, modalFooterComponentProps = {}, }) => {
    const [openStatus, setOpenStatus] = useState(isOpen);
    const [contentWithScrollbar, setContentWithScrollbar] = useState(false);
    const containerRef = useRef(null);
    const contentRef = useRef(null);
    const handleClose = useCallback(() => {
        setOpenStatus(false);
    }, []);
    const handleContainerClick = useCallback((event) => {
        event.stopPropagation();
    }, []);
    useEffect(() => {
        if (contentRef && contentRef.current && hasElementScrollbar(contentRef.current)) {
            setContentWithScrollbar(true);
        }
    }, []);
    useEffect(() => {
        setOpenStatus(isOpen);
    }, [isOpen]);
    useEffect(() => {
        if (openStatus) {
            onOpen();
        }
        else {
            onClose();
        }
    }, [openStatus]);
    if (!openStatus) {
        return null;
    }
    return (React.createElement(Portal, null,
        React.createElement(StyledContainer, { className: className },
            React.createElement(StyledOverlay, { className: overlayClassName, onClick: handleClose },
                React.createElement(StyledInnerContainer, { ref: containerRef, className: containerClassName, onClick: handleContainerClick },
                    React.createElement(StyledHeader, { className: headerClassName },
                        title && React.createElement(StyledTitle, { className: titleClassName }, title),
                        React.createElement(StyledIcon, { className: closeIconClassName, icon: IconLookup.CROSS, onClick: handleClose })),
                    React.createElement(StyledContent, { className: contentClassName, ref: contentRef, hasScrollbar: contentWithScrollbar, existsTitle: !!title }, children),
                    ModalFooter && React.createElement(ModalFooter, Object.assign({}, modalFooterComponentProps)))))));
};
export default Modal;
